import { Routes, Route } from 'react-router-dom';
import LoginPage from './LoginPage';
import DashboardBroker from './DashboardBroker';
import DashboardAgenzia from './DashboardAgenzia';
import GestisciPolizze from './GestisciPolizze';
import AggiornaProfilo from './AggiornaProfilo';
import ForcedPasswordChange from './ForcedPasswordChange';
import ResetPassword from './ResetPassword';
import DashboardAgente from './DashboardAgente';
import NuovaPolizza from './NuovaPolizza'; // <--- Importiamo NuovaPolizza
import CreaAgenzia from './CreaAgenzia';
import GestisciAgenzie from './GestisciAgenzie';
import CreaAgente from './CreaAgente';
import GestisciAgenti from './GestisciAgenti';
import GestisciAgentiAgenzia from './GestisciAgentiAgenzia';
import GestisciPacchettiGaranzia from './GestisciPacchettiGaranzia';
import GestisciPolizzeAgente from './GestisciPolizzeAgente';
import GestisciPolizzeAgenzia from './GestisciPolizzeAgenzia';
import AnnullaPolizza from './AnnullaPolizza';
import PolizzeScartate from './PolizzeScartate';

function App() {
  return (
    <Routes>
      {/* Rotte di autenticazione */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/forced-password-change" element={<ForcedPasswordChange />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* ======================== DASHBOARD BROKER ======================== */}
      <Route path="/dashboard/broker" element={<DashboardBroker />}>
        <Route index element={<GestisciPolizze />} /> {/* Gestisci Polizze */}
         <Route path="annulla-polizza" element={<AnnullaPolizza />} />
        <Route path="crea-agenzia" element={<CreaAgenzia />} />
        <Route path="gestisci-agenzie" element={<GestisciAgenzie />} />
        <Route path="crea-agente" element={<CreaAgente />} />
        <Route path="gestisci-agenti" element={<GestisciAgenti />} />
        <Route path="polizze-scartate" element={<PolizzeScartate />} />
        <Route path="profilo" element={<AggiornaProfilo />} />
      </Route>

      {/* ======================== DASHBOARD AGENZIA ======================== */}
      <Route path="/dashboard/agenzia" element={<DashboardAgenzia />}>
        <Route index element={<GestisciPolizzeAgenzia />} />
        <Route path="annulla-polizza" element={<AnnullaPolizza />} />
        <Route path="crea-agente" element={<CreaAgente />} />
        <Route path="gestisci-agenti-agenzia" element={<GestisciAgentiAgenzia />} />
        <Route path="profilo" element={<AggiornaProfilo />} />
      </Route>

      {/* ======================== DASHBOARD AGENTE ======================== */}
      <Route path="/dashboard/agente" element={<DashboardAgente />}>
        {/* ⭐ MODIFICATO: NuovaPolizza come pagina iniziale predefinita per l'agente ⭐ */}
        <Route index element={<NuovaPolizza />} /> 
        {/* ⭐ NUOVA ROTTA: Per il link "Crea Nuova Polizza" se vuoi una rotta esplicita ⭐ */}
        {/* Se vuoi che la home e "Crea Nuova Polizza" siano la stessa cosa, puoi rimuovere questa riga. */}
        {/* Ma averla esplicita è una buona pratica se in futuro l'index cambierà. */}
        <Route path="crea-nuova-polizza" element={<NuovaPolizza />} />
        <Route path="annulla-polizza" element={<AnnullaPolizza />} />

        <Route path="gestisci-commessa" element={<div>Pagina Gestisci Commessa (Operatore)</div>} />
        <Route path="profilo" element={<AggiornaProfilo />} />
        {/* Aggiungi qui altre rotte specifiche dell'agente */}
        <Route path="mie-polizze" element={<div>Pagina Le Mie Polizze (TODO)</div>} /> {/* Segnaposto per "Le Mie Polizze" */}
        <Route path="gestisci-mie-polizze" element={<GestisciPolizzeAgente />} /> 
      </Route>
    </Routes>
  );
}

export default App;